export default "__VITE_ASSET__CskNzcCF__"